import React from "react";

const UBS = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path d="M7 6.813v8.937h11.49l-.598-.457L7 6.813z" fill="#60B158" />
      <path
          d="M28.232 6.813v8.937h-11.49l.597-.457 10.893-8.48z"
          fill="#FFA700"
      />
      <path
          d="M17.616 10.75a4.373 4.373 0 004.37-4.375A4.373 4.373 0 0017.617 2a4.373 4.373 0 00-4.372 4.375 4.373 4.373 0 004.372 4.375z"
          fill="#007AFF"
      />
      <path
          d="M7 15.75h21.232v7.625C28.232 29.243 23.479 34 17.616 34 11.753 34 7 29.243 7 23.375V15.75z"
          fill="#0E71C3"
      />
    </svg>
);

export default UBS;
